import React from 'react';
import { howItWorksSteps } from '../../data/mock';
import { FileText, DollarSign, Key } from 'lucide-react';

const icons = [FileText, DollarSign, Key];

const HowItWorksSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-slate-100 text-slate-700 rounded-full text-sm font-semibold mb-4">
            Simple Process
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Our streamlined process makes selling or buying properties fast and hassle-free.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {howItWorksSteps.map((step, index) => {
            const IconComponent = icons[index];
            return (
              <div 
                key={step.id} 
                className="relative group"
              >
                {/* Connector Line */}
                {index < howItWorksSteps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-slate-200"></div>
                )}
                
                <div className="relative bg-slate-50 rounded-2xl p-8 hover:bg-slate-100 transition-all duration-300 h-full">
                  {/* Step Number */}
                  <div className="absolute -top-4 -left-2 w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center text-sm font-bold shadow-lg">
                    {step.id}
                  </div>
                  
                  {/* Icon */}
                  <div className="w-16 h-16 rounded-2xl bg-white shadow-md flex items-center justify-center mb-6 group-hover:shadow-lg transition-shadow">
                    <IconComponent className="w-8 h-8 text-emerald-600" />
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
